import {useCallback, useEffect, useRef, useState} from "react";
import FeaturesSection from "./components/FeaturesSection";
import HeroSection from "./components/HeroSection";
import HomeTopbar, {homeNavItems} from "./components/HomeTopbar";
import NewsSection from "./components/NewsSection";
import RoleDetailModal from "./components/RoleDetailModal";
import RolesSection from "./components/RolesSection";
import VideoModal from "./components/VideoModal";
import {newsList, reservationCode, reservationSubmit} from "../api/api";
import {buildNewsLists, emptyNewsLists, newsTabs} from "../news/newsData";
import newsIndexImage from "../assets/images/news/ss.jpg";
import newsIndexImage2x from "../assets/images/news/news_index_image@2x.png";
import featureImage1 from "../assets/images/feature/feat_image_1.png";
import featureImage2 from "../assets/images/feature/feat_image_2.png";
import featureImage3 from "../assets/images/feature/feat_image_3.png";
import featureImage4 from "../assets/images/feature/feat_image_4.png";
import featureTitle1 from "../assets/images/feature/feat_title_1.png";
import featureTitle1_2x from "../assets/images/feature/feat_title_1@2x.png";
import featureTitle2 from "../assets/images/feature/feat_title_2.png";
import featureTitle2_2x from "../assets/images/feature/feat_title_2@2x.png";
import featureTitle3 from "../assets/images/feature/feat_title_3.png";
import featureTitle3_2x from "../assets/images/feature/feat_title_3@2x.png";
import featureTitle4 from "../assets/images/feature/feat_title_4.png";
import featureTitle4_2x from "../assets/images/feature/feat_title_4@2x.png";
import footerLogo from "../assets/images/foot/footer_logo.png";
import popupLine02 from "../assets/images/popup/popup_line_02.png";
import {roleData} from "./roleData";
import "./HomePage.css";

const CDN_BASE_URL = (process.env.REACT_APP_CDN_BASE_URL || process.env.PUBLIC_URL || "").replace(/\/$/, "");
const buildMediaUrl = function (path) {
    if (/^https?:\/\//.test(path)) return path;
    if (!CDN_BASE_URL) return path;
    return `${CDN_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};
const HERO_VIDEO_URL = buildMediaUrl(process.env.REACT_APP_HERO_VIDEO_URL || "/videos/home-v1.mp4");
const HERO_VIDEO_POSTER_URL = buildMediaUrl(process.env.REACT_APP_HERO_VIDEO_POSTER_URL || "/videos/home-v1.jpg");

const navItems = homeNavItems;

const legacySectionIds = {
    first: "home",
    roles: "char",
    features: "feature"
};

const secondaryRoutePattern = /^\/(?:newsdetail\/[^/?#]+|user-agreement|privacy-policy|contact-us)(?:[/?#]|$)/;

const getSectionIdFromHash = function () {
    const hashId = (window.location.hash || "").replace(/^#/, "");
    return legacySectionIds[hashId] || hashId;
};

const getSectionIndexFromHash = function () {
    const sectionId = getSectionIdFromHash();
    const sectionIndex = navItems.findIndex(function (item) { return item.id === sectionId; });
    return sectionIndex >= 0 ? sectionIndex : 0;
};

const newsBannerItems = [
    {
        id: "news-index",
        src: newsIndexImage,
        src2x: newsIndexImage2x,
        alt: "新闻主图"
    }
];

const NEWS_PAGE_SIZE = 4;
const initialNewsLists = emptyNewsLists();

const featureItems = [
    {
        id: "sunlight",
        src: featureImage1,
        titleImage: featureTitle1,
        titleImage2x: featureTitle1_2x,
        titleWidth: 317,
        titleHeight: 88,
        titleLeft: 23,
        titleBottom: 196,
        titleLineWidth: 179,
        alt: "游戏特色 沉浸探索",
        title: "目光相逢",
        description: "第一视角卡面，定格你亲眼看见的瞬间。"
    },
    {
        id: "voyage",
        src: featureImage2,
        titleImage: featureTitle2,
        titleImage2x: featureTitle2_2x,
        titleWidth: 255,
        titleHeight: 108,
        titleLeft: 23,
        titleBottom: 169,
        titleLineWidth: 184,
        alt: "游戏特色 角色故事",
        title: "时空迷局",
        description: "穿过无限推演，揭开现实被遮蔽的真相。"
    },
    {
        id: "space-time",
        src: featureImage3,
        titleImage: featureTitle3,
        titleImage2x: featureTitle3_2x,
        titleWidth: 382,
        titleHeight: 125,
        titleLeft: 24,
        titleBottom: 169,
        titleLineWidth: 187,
        alt: "游戏特色 羁绊时空",
        title: "朝夕相伴",
        description: "登录即见他的身影，轻触互动开启日常陪伴。"
    },
    {
        id: "resonance",
        src: featureImage4,
        titleImage: featureTitle4,
        titleImage2x: featureTitle4_2x,
        titleWidth: 264,
        titleHeight: 108,
        titleLeft: 23,
        titleBottom: 169,
        titleLineWidth: 186,
        alt: "游戏特色 情感共鸣",
        title: "羁绊养成",
        description: "培养专属卡面，解锁与他的更多故事。"
    }
];

const normalizeIndex = function (index, length) {
    return (index + length) % length;
};

const phoneRegexp = /^1[3-9]\d{9}$/;

const initialReservationForm = {
    platforms: ["android"],
    phone: "",
    code: ""
};

const reservationPlatformOptions = [
    {value: "android", label: "安卓"},
    {value: "ios", label: "iOS"}
];

export default function HomePage({isMusicOn, onMusicToggle, onMusicPause, onMusicPlay}) {
    const [activeSectionIndex, setActiveSectionIndex] = useState(getSectionIndexFromHash);
    const [bannerIndex, setBannerIndex] = useState(0);
    const [activeNewsTab, setActiveNewsTab] = useState("latest");
    const [newsPage, setNewsPage] = useState(1);
    const [newsLists, setNewsLists] = useState(initialNewsLists);
    const [isNewsLoading, setIsNewsLoading] = useState(false);
    const [activeRoleIndex, setActiveRoleIndex] = useState(null);
    const [isRoleDetailOpen, setIsRoleDetailOpen] = useState(false);
    const [isVideoOpen, setIsVideoOpen] = useState(false);
    const [isReservationOpen, setIsReservationOpen] = useState(false);
    const [isReservationSuccess, setIsReservationSuccess] = useState(false);
    const [hasAcceptedReservationTerms, setHasAcceptedReservationTerms] = useState(false);
    const [reservedPhone, setReservedPhone] = useState("");
    const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
    const [reservationForm, setReservationForm] = useState(initialReservationForm);
    const [reservationMessage, setReservationMessage] = useState("");
    const [reservationSuccessMessage, setReservationSuccessMessage] = useState("");
    const [codeCountdown, setCodeCountdown] = useState(0);
    const [isCodeLoading, setIsCodeLoading] = useState(false);
    const [isReservationSubmitting, setIsReservationSubmitting] = useState(false);
    const activeSectionIndexRef = useRef(activeSectionIndex);
    const wheelLockRef = useRef(false);
    const wheelUnlockTimerRef = useRef(null);
    const newsViewRef = useRef(null);
    const currentVoiceAudioRef = useRef(null);
    const wasMusicPlayingBeforeVoiceRef = useRef(false);
    const wasMusicPlayingBeforeVideoRef = useRef(false);
    const activeNavId = navItems[activeSectionIndex].id;

    const stopRoleVoice = useCallback(function ({restoreMusic = true} = {}) {
        const audio = currentVoiceAudioRef.current;
        if (audio) {
            currentVoiceAudioRef.current = null;
            audio.onended = null;
            audio.onerror = null;
            audio.pause();
            audio.currentTime = 0;
        }

        if (restoreMusic) {
            if (wasMusicPlayingBeforeVoiceRef.current && typeof onMusicPlay === "function") {
                onMusicPlay();
            }
            wasMusicPlayingBeforeVoiceRef.current = false;
        }
    }, [onMusicPlay]);

    const showSectionIndex = useCallback(function (nextIndex, updateHash) {
        const clampedIndex = Math.min(navItems.length - 1, Math.max(0, nextIndex));
        const targetItem = navItems[clampedIndex];

        activeSectionIndexRef.current = clampedIndex;
        setActiveSectionIndex(clampedIndex);

        if (clampedIndex === navItems.length - 1 && newsViewRef.current) {
            newsViewRef.current.scrollTop = 0;
        }

        if (updateHash && window.location.hash !== targetItem.href) {
            window.location.hash = targetItem.href;
        }
    }, []);

    useEffect(() => {
        const syncSectionFromHash = function () {
            const rawHashId = (window.location.hash || "").replace(/^#/, "");
            const shouldOpenReservation = rawHashId === "reservation";

            // Secondary routes are owned by App and unmount this page.
            if (secondaryRoutePattern.test(rawHashId)) return;

            const canonicalId = legacySectionIds[rawHashId] || rawHashId;
            const targetIndex = navItems.findIndex(function (item) { return item.id === canonicalId; });
            const resolvedIndex = targetIndex >= 0 ? targetIndex : 0;
            const resolvedId = navItems[resolvedIndex].id;

            setIsRoleDetailOpen(false);
            setIsVideoOpen(false);
            setIsReservationOpen(shouldOpenReservation);
            showSectionIndex(resolvedIndex, false);

            if (rawHashId !== resolvedId) {
                window.history.replaceState(
                    null,
                    "",
                    `${window.location.pathname}${window.location.search}#${resolvedId}`
                );
            }
        };

        syncSectionFromHash();
        window.addEventListener("hashchange", syncSectionFromHash);

        return () => {
            window.removeEventListener("hashchange", syncSectionFromHash);
        };
    }, [showSectionIndex]);

    useEffect(() => {
        document.body.classList.add("home-page-active");
        window.scrollTo(0, 0);

        return () => {
            document.body.classList.remove("home-page-active");
        };
    }, []);

    useEffect(() => {
        const clamp = function (value, min, max) { return Math.min(max, Math.max(min, value)); };
        const setRem = function () {
            const width = clamp(document.documentElement.clientWidth || 1920, 1300, 1920);
            document.documentElement.style.fontSize = (width / 1920 * 100) + "px";
        };

        setRem();
        window.addEventListener("resize", setRem);

        return () => {
            window.removeEventListener("resize", setRem);
        };
    }, []);

    useEffect(() => {
        activeSectionIndexRef.current = activeSectionIndex;
    }, [activeSectionIndex]);

    useEffect(() => {
        if (newsBannerItems.length <= 1) return undefined;
        const timerId = window.setInterval(function () {
            setBannerIndex(function (index) { return normalizeIndex(index + 1, newsBannerItems.length); });
        }, 3500);

        return () => {
            window.clearInterval(timerId);
        };
    }, []);

    useEffect(() => {
        setBannerIndex(function (index) {
            if (newsBannerItems.length <= 0) return 0;
            return Math.min(index, newsBannerItems.length - 1);
        });
    }, []);

    useEffect(() => {
        let alive = true;

        async function loadNews() {
            setIsNewsLoading(true);
            const response = await newsList({limit: 30});
            const result = response && response.data;

            if (alive && result && result.code === 0) {
                const items = (result.data && result.data.items) || [];
                setNewsLists(buildNewsLists(items));
            }

            if (alive) setIsNewsLoading(false);
        }

        loadNews();

        return () => {
            alive = false;
        };
    }, []);

    useEffect(() => {
        const handleKeyDown = function (event) {
            if (event.key === "Escape") {
                setIsReservationOpen(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (codeCountdown <= 0) return undefined;

        const timerId = window.setInterval(function () {
            setCodeCountdown(function (countdown) { return Math.max(countdown - 1, 0); });
        }, 1000);

        return () => {
            window.clearInterval(timerId);
        };
    }, [codeCountdown]);

    useEffect(() => {
        return () => {
            stopRoleVoice();
        };
    }, [stopRoleVoice]);

    useEffect(() => {
        const wheelThreshold = 20;
        const wheelLockMs = 900;

        const handleWheel = function (event) {
            if (isRoleDetailOpen) {
                event.preventDefault();
                return;
            }
            if (isReservationOpen) {
                setIsReservationOpen(false);
                setIsReservationSuccess(false);
            }
            if (isVideoOpen) return;
            if (Math.abs(event.deltaY) < wheelThreshold) return;

            const direction = event.deltaY > 0 ? 1 : -1;
            const currentIndex = activeSectionIndexRef.current;
            const nextIndex = Math.min(navItems.length - 1, Math.max(0, currentIndex + direction));
            const isLastSection = currentIndex === navItems.length - 1;
            const newsView = newsViewRef.current;

            if (wheelLockRef.current) {
                event.preventDefault();
                return;
            }

            if (isLastSection && direction > 0) return;
            if (isLastSection && direction < 0 && newsView && newsView.scrollTop > 2) return;
            if (nextIndex === currentIndex) return;

            event.preventDefault();

            wheelLockRef.current = true;
            showSectionIndex(nextIndex, true);

            if (wheelUnlockTimerRef.current) {
                window.clearTimeout(wheelUnlockTimerRef.current);
            }

            wheelUnlockTimerRef.current = window.setTimeout(function () {
                wheelLockRef.current = false;
            }, wheelLockMs);
        };

        window.addEventListener("wheel", handleWheel, {passive: false});

        return () => {
            window.removeEventListener("wheel", handleWheel);
            if (wheelUnlockTimerRef.current) {
                window.clearTimeout(wheelUnlockTimerRef.current);
                wheelUnlockTimerRef.current = null;
            }
            wheelLockRef.current = false;
        };
    }, [isReservationOpen, isVideoOpen, isRoleDetailOpen, showSectionIndex]);

    const handleNavClick = function (event, href) {
        event.preventDefault();
        setIsRoleDetailOpen(false);
        stopRoleVoice();
        const targetIndex = navItems.findIndex(function (item) { return item.href === href; });
        if (targetIndex >= 0) showSectionIndex(targetIndex, true);
    };

    const handleOpenVideo = function () {
        const shouldRestoreMusicAfterVoice = wasMusicPlayingBeforeVoiceRef.current;
        stopRoleVoice({restoreMusic: false});
        wasMusicPlayingBeforeVoiceRef.current = false;
        const wasMusicPlaying = typeof onMusicPause === "function" && onMusicPause() === true;
        wasMusicPlayingBeforeVideoRef.current = shouldRestoreMusicAfterVoice || wasMusicPlaying;
        setIsVideoOpen(true);
    };

    const handleCloseVideo = useCallback(function () {
        setIsVideoOpen(false);
        if (wasMusicPlayingBeforeVideoRef.current && typeof onMusicPlay === "function") {
            onMusicPlay();
        }
        wasMusicPlayingBeforeVideoRef.current = false;
    }, [onMusicPlay]);

    const handleRoleChange = useCallback(function (index) {
        setActiveRoleIndex(index);
        stopRoleVoice();
    }, [stopRoleVoice]);

    const handleOpenRoleDetail = function (index) {
        if (!Number.isInteger(index) || index < 0 || index >= roleData.length) return;
        handleRoleChange(index);
        setIsRoleDetailOpen(true);
    };

    const handleCloseRoleDetail = useCallback(function () {
        setIsRoleDetailOpen(false);
        stopRoleVoice();
    }, [stopRoleVoice]);

    const handlePrevRoleDetail = useCallback(function () {
        handleRoleChange(normalizeIndex(activeRoleIndex - 1, roleData.length));
    }, [activeRoleIndex, handleRoleChange]);

    const handleNextRoleDetail = useCallback(function () {
        handleRoleChange(normalizeIndex(activeRoleIndex + 1, roleData.length));
    }, [activeRoleIndex, handleRoleChange]);

    const handleRoleVoicePlay = function (audioUrl) {
        if (!audioUrl) return;

        if (currentVoiceAudioRef.current) {
            stopRoleVoice({restoreMusic: false});
        } else {
            wasMusicPlayingBeforeVoiceRef.current = typeof onMusicPause === "function" && onMusicPause() === true;
        }

        const audio = new Audio(audioUrl);
        audio.preload = "auto";
        currentVoiceAudioRef.current = audio;
        const finishVoicePlayback = function () {
            if (currentVoiceAudioRef.current !== audio) return;
            currentVoiceAudioRef.current = null;
            audio.onended = null;
            audio.onerror = null;
            if (wasMusicPlayingBeforeVoiceRef.current && typeof onMusicPlay === "function") {
                onMusicPlay();
            }
            wasMusicPlayingBeforeVoiceRef.current = false;
        };

        audio.onended = finishVoicePlayback;
        audio.onerror = finishVoicePlayback;
        audio.play().catch(finishVoicePlayback);
    };

    const handleNewsTabChange = function (tabKey) {
        setActiveNewsTab(tabKey);
        setNewsPage(1);
    };

    const handleNewsPageChange = function (page) {
        setNewsPage(page);
    };

    const handleOpenReservation = function () {
        setReservationMessage("");
        setReservationSuccessMessage("");
        setIsReservationSuccess(false);
        setHasAcceptedReservationTerms(false);
        setIsUserMenuOpen(false);
        setIsReservationOpen(true);
    };

    const handleCloseReservation = function () {
        setIsReservationOpen(false);
        setIsReservationSuccess(false);
    };

    const handleReservationChange = function (field, value) {
        setReservationForm(function (form) {
            return {...form, [field]: value};
        });
        setReservationMessage("");
    };

    const handleReservationPlatformToggle = function (platform) {
        setReservationForm(function (form) {
            const platforms = form.platforms.includes(platform)
                ? form.platforms.filter(function (item) { return item !== platform; })
                : [...form.platforms, platform];

            return {...form, platforms};
        });
        setReservationMessage("");
    };

    const handleSendReservationCode = async function () {
        const phone = reservationForm.phone.trim();
        if (!phoneRegexp.test(phone)) {
            setReservationMessage("请输入正确的手机号");
            return;
        }

        setIsCodeLoading(true);
        setReservationMessage("");
        const response = await reservationCode({phone});
        const result = response && response.data;
        setIsCodeLoading(false);

        if (!result || result.code !== 0) {
            setReservationMessage((result && result.message) || "验证码获取失败，请稍后再试");
            return;
        }

        setCodeCountdown((result.data && result.data.cooldown) || 60);
        setReservationMessage("验证码已发送，请输入后完成预约");
    };

    const handleReservationSubmit = async function (event) {
        event.preventDefault();
        const phone = reservationForm.phone.trim();
        const code = reservationForm.code.trim();

        if (!phoneRegexp.test(phone)) {
            setReservationMessage("请输入正确的手机号");
            return;
        }
        if (!/^\d{6}$/.test(code)) {
            setReservationMessage("请输入6位验证码");
            return;
        }
        if (!hasAcceptedReservationTerms) {
            setReservationMessage("请先阅读并同意用户协议和隐私协议");
            return;
        }

        setIsReservationSubmitting(true);
        setReservationMessage("");
        const response = await reservationSubmit({
            platform: reservationForm.platforms.join(","),
            platforms: reservationForm.platforms,
            phone,
            code
        });
        const result = response && response.data;
        setIsReservationSubmitting(false);

        if (!result || result.code !== 0) {
            setReservationMessage((result && result.message) || "预约失败，请稍后再试");
            return;
        }

        setReservationSuccessMessage("感谢你的预约，期待爱的相见。");
        setReservedPhone(phone);
        setIsUserMenuOpen(false);
        setIsReservationSuccess(true);
        setReservationForm(initialReservationForm);
        setHasAcceptedReservationTerms(false);
        setCodeCountdown(0);
    };

    const handleUserClick = function () {
        if (!reservedPhone) {
            handleOpenReservation();
            return;
        }
        setIsUserMenuOpen(function (value) { return !value; });
    };

    const handleUserLogout = function () {
        setReservedPhone("");
        setIsUserMenuOpen(false);
    };

    const isReservationFormComplete = phoneRegexp.test(reservationForm.phone.trim())
        && /^\d{6}$/.test(reservationForm.code.trim())
        && reservationForm.platforms.length > 0
        && hasAcceptedReservationTerms;

    return (
        <>
            <HomeTopbar
                activeNavId={activeNavId}
                onNavClick={handleNavClick}
                isMusicOn={isMusicOn}
                onMusicToggle={onMusicToggle}
                onReserveClick={handleOpenReservation}
                isUserMenuOpen={isUserMenuOpen}
                userPhone={reservedPhone}
                onUserClick={handleUserClick}
                onUserLogout={handleUserLogout}
            />

            <main className="wraps home-page-views">
                <div
                    className={activeSectionIndex === 0 ? "home-view active" : "home-view"}
                    aria-hidden={activeSectionIndex !== 0}
                >
                    <HeroSection
                        onPlayClick={handleOpenVideo}
                        onPreregisterClick={handleOpenReservation}
                    />
                </div>

                <div
                    className={activeSectionIndex === 1 ? "home-view active" : "home-view"}
                    aria-hidden={activeSectionIndex !== 1}
                >
                    <RolesSection
                        roles={roleData}
                        activeRoleIndex={activeRoleIndex}
                        onRoleChange={handleRoleChange}
                        onRoleDetailOpen={handleOpenRoleDetail}
                    />
                </div>

                <div
                    className={activeSectionIndex === 2 ? "home-view active" : "home-view"}
                    aria-hidden={activeSectionIndex !== 2}
                >
                    <FeaturesSection featureItems={featureItems} />
                </div>

                <div
                    ref={newsViewRef}
                    className={activeSectionIndex === 3 ? "home-view home-view--news active" : "home-view home-view--news"}
                    aria-hidden={activeSectionIndex !== 3}
                >
                    <NewsSection
                        bannerItems={newsBannerItems}
                        bannerIndex={bannerIndex}
                        onBannerDotClick={setBannerIndex}
                        newsTabs={newsTabs}
                        newsLists={newsLists}
                        activeNewsTab={activeNewsTab}
                        activeNewsPage={newsPage}
                        newsPageSize={NEWS_PAGE_SIZE}
                        onNewsTabChange={handleNewsTabChange}
                        onNewsPageChange={handleNewsPageChange}
                        isNewsLoading={isNewsLoading}
                    />

                    <footer className="footer">
                        <div className="footer-inner">
                            <div className="footer-logo">
                                <img src={footerLogo} alt="月迁网络 LUNARING" />
                            </div>
                            <div className="footer-content">
                                <nav className="footer-links" aria-label="底部链接">
                                    <a href="#/user-agreement">用户协议</a>
                                    <a href="#/privacy-policy">隐私协议</a>
                                    <a href="#/contact-us">联系我们</a>
                                </nav>
                                <div className="footer-health-notice">
                                    <p>健康游戏忠告：</p>
                                    <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。</p>
                                    <p>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
                                </div>
                                <p className="footer-records">
                                    <a href="https://beian.mps.gov.cn/" target="_blank" rel="noreferrer">沪公网安备31011002007993号</a>
                                    <a className="icp_word" href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">沪ICP备2024053816号-4</a>
                                </p>
                                <p className="footer-operator">运营方：上海月迁网络科技有限公司</p>
                            </div>
                        </div>
                    </footer>
                </div>
            </main>

            <RoleDetailModal
                isOpen={isRoleDetailOpen}
                role={roleData[activeRoleIndex]}
                roleIndex={activeRoleIndex}
                totalRoles={roleData.length}
                onClose={handleCloseRoleDetail}
                onPrev={handlePrevRoleDetail}
                onNext={handleNextRoleDetail}
                onVoicePlay={handleRoleVoicePlay}
                onVideoPlay={handleOpenVideo}
            />

            <VideoModal
                isOpen={isVideoOpen}
                src={HERO_VIDEO_URL}
                poster={HERO_VIDEO_POSTER_URL}
                onClose={handleCloseVideo}
            />

            <div
                className={isReservationOpen ? "mask open" : "mask"}
                aria-hidden={isReservationOpen ? "false" : "true"}
                onClick={(event) => {
                    if (event.target === event.currentTarget) handleCloseReservation();
                }}
            >
                <div className={isReservationSuccess ? "reservation-modal reservation-success-modal" : "reservation-modal"} role="dialog" aria-modal="true" aria-labelledby="reservationTitle">
                    <button className="modal-close" type="button" aria-label="关闭预约弹窗" onClick={handleCloseReservation}>×</button>
                    {isReservationSuccess ? (
                        <div className="reservation-success-content">
                            <h3 className="reservation-modal-title" id="reservationTitle">预约成功</h3>
                            <p>{reservationSuccessMessage}</p>
                            <div className="reservation-success-actions">
                                <button className="reservation-success-secondary" type="button" onClick={handleCloseReservation}>关闭</button>
                            </div>
                        </div>
                    ) : (
                        <>
                        <div className="reservation-submit-modal">
                            <header className="reservation-modal-header">
                                <h3 className="reservation-modal-title" id="reservationTitle">欢迎预约</h3>
                                <p>玩家你好，请录入信息。</p>
                            </header>
                            <form className="reservation-form" onSubmit={handleReservationSubmit}>
                                <label className="reservation-field">
                                    <span className="reservation-visually-hidden">手机号码</span>
                                    <input
                                        type="tel"
                                        value={reservationForm.phone}
                                        maxLength="11"
                                        placeholder="请输入手机号"
                                        onChange={(event) => handleReservationChange("phone", event.target.value.replace(/\D/g, ""))}
                                    />
                                </label>
                                <label className="reservation-field reservation-code-field">
                                    <span className="reservation-visually-hidden">验证码</span>
                                    <span className="reservation-code-row">
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            value={reservationForm.code}
                                            maxLength="6"
                                            placeholder="请输入验证码"
                                            onChange={(event) => handleReservationChange("code", event.target.value.replace(/\D/g, ""))}
                                        />
                                        <button
                                            className="reservation-code-btn"
                                            type="button"
                                            disabled={isCodeLoading || codeCountdown > 0}
                                            onClick={handleSendReservationCode}
                                        >
                                            {isCodeLoading ? "发送中" : (codeCountdown > 0 ? `${codeCountdown}s` : "发送验证码")}
                                        </button>
                                    </span>
                                </label>
                                <label className="reservation-agreement">
                                    <input
                                        type="checkbox"
                                        checked={hasAcceptedReservationTerms}
                                        onChange={(event) => {
                                            setHasAcceptedReservationTerms(event.target.checked);
                                            setReservationMessage("");
                                        }}
                                    />
                                    <span>已同意</span>
                                    <a href="#/user-agreement">《用户协议》</a>
                                    <a href="#/privacy-policy">《隐私协议》</a>
                                </label>
                                <div className="reservation-platform-title">
                                    <img src={popupLine02} alt="" aria-hidden="true"/>
                                    <span>预约平台（可多选）</span>
                                </div>
                                <div className="reservation-platforms">
                                    {reservationPlatformOptions.map(function (option) {
                                        const isSelected = reservationForm.platforms.includes(option.value);

                                        return (
                                            <label key={option.value} className={isSelected ? "selected" : ""}>
                                                <input
                                                    type="checkbox"
                                                    name="platforms"
                                                    value={option.value}
                                                    checked={isSelected}
                                                    onChange={() => handleReservationPlatformToggle(option.value)}
                                                />
                                                <span>{option.label}</span>
                                            </label>
                                        );
                                    })}
                                </div>
                              
                                <button className="reservation-submit" type="submit" disabled={!isReservationFormComplete || isReservationSubmitting}>
                                    {isReservationSubmitting ? "提交中" : "提交预约"}
                                </button>
                                  <div className="reservation-feedback" aria-live="polite">
                                    {reservationMessage && <p className="reservation-message">{reservationMessage}</p>}
                                </div>
                            </form>
                        </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
